import axios, { AxiosError, AxiosInstance } from 'axios';
import axiosRetry, { isNetworkError, isRetryableError } from 'axios-retry';

export class AxiosRetryUtil {
    private static instance: AxiosInstance | null;

    static getInstance(): AxiosInstance {
        if (!this.instance) {
            this.instance = axios.create();

            axiosRetry(this.instance, {
                retries: 3,
                /* https://github.com/softonic/axios-retry/blob/master/src/index.ts#L114
                 * Overriding the default retryCondition to allow retries for POST requests
                 */
                retryCondition: (error: AxiosError) => isNetworkError(error) || isRetryableError(error),
                retryDelay: (retryCount, error) => {
                    return axiosRetry.exponentialDelay(retryCount, error, 1000);
                },
                shouldResetTimeout: true,
            });
        }
        return this.instance;
    }
}
